import { flow, isEqual, omitBy } from 'lodash/fp';
import { getFormValues } from 'redux-form';
import { createStructuredSelector } from 'reselect';

import stringifyAdsQuery from 'components/searchAds/stringifyAdsQuery';
import formToQuery from 'components/searchAds/mappers/formToQuery';
import formScaffolding from 'components/searchAds/mappers/formScaffolding';
import { EXTRA_FILTERS_QUERY_KEY } from 'components/searchAds/SearchLayout/constants';
import { getSearchUrl } from 'helpers/namedUrls';
import { selectCarMakeById } from 'store/ducks/manufacturers';

const getSearchLinkSelector = (form, extraFilters) => (state) => {
  const formValues = getFormValues(form)(state);
  const carMakeById = selectCarMakeById(state);
  const query = flow(
    omitBy((value, key) => isEqual(formScaffolding[key], value)),
    formToQuery(carMakeById),
  )(formValues);
  const finalQuery = extraFilters
    ? { ...query, [EXTRA_FILTERS_QUERY_KEY]: 1 }
    : query;

  return `${getSearchUrl()}${stringifyAdsQuery(finalQuery)}`;
};

export default (form) => {
  const selector = getSearchLinkSelector(form, false);
  const selectorExtra = getSearchLinkSelector(form, true);

  return createStructuredSelector({
    searchLink: selector,
    searchLinkExtra: selectorExtra,
  });
};
